import MobileHeader from '../../components/mobile/MobileHeader';
import MobileMemberDashboard from '../../components/mobile/MobileMemberDashboard';
import MobileBottomNav from '../../components/mobile/MobileBottomNav';
import { NotificationCenter } from '../../components/common/NotificationCenter/NotificationCenter';
import type { Notification } from '../../services/notificationsApi';

const MobileMemberDashboardPage = () => {

  const handleNotificationClick = (notification: Notification) => {
    console.log('Notification clicked:', notification);
    // Could add navigation logic here based on notification type
  };


  return (
    <div>
      <MobileHeader
        title="會員中心"
        showBack={false}
        rightAction={<NotificationCenter onNotificationClick={handleNotificationClick} />}
      />
      <MobileMemberDashboard />
      <MobileBottomNav />
    </div>
  );
};

export default MobileMemberDashboardPage;
